<ftr-table-column-header
  *ngIf="!hideHeader"
  [columns]="columns"
  [verticalBreakpoint]="verticalBreakpoint"
></ftr-table-column-header>
<div
  class="table-body"
  *ngFor="let item of items; trackBy: trackBy"
  [attr.data-id]="item.id"
  [routerLink]="routerLinkFn ? routerLinkFn(item) : undefined"
  [ngClass]="getRowClasses()"
>
  <div *ngFor="let column of columns; index as i" class="table-body__row" [ngClass]="getColumnClasses(column)">
    <span class="table-body__heading">{{ column.name }}</span>
    <ftr-table-cell
      class="table-body__cell"
      [ngClass]="'table-body__cell__' + column.alignment + ' table-body__cell__' + verticalBreakpoint"
      [columnName]="column.name"
      [cell]="column.getCell(item)"
      [cellType]="column.type"
      [verticalBreakpoint]="verticalBreakpoint"
    ></ftr-table-cell>
  </div>
</div>
